module.exports = __webpack_public_path__ + "media/images/certificates-bg-c1732a7926ee36bbfe01000956cc5078.svg";